import {connect} from 'react-redux';
import {PowerSupplyControls as Component} from './PowerSupplyControls';
import {
  showModal,
  incPowerSupplyTime,
  decPowerSupplyTime,
  countDownPowerSupplyTime,
  resetPowerSupplyTime,
  incPowerSupplyAmp,
  decPowerSupplyAmp,
  incPowerSupplyWatt,
  decPowerSupplyWatt,
  incPowerSupplyVoltage,
  decPowerSupplyVoltage,
  togglePowerSupplyPower,
  togglePowerSupplyStart,
  setGelResult
} from '@learningblocks/protocol-redux/lib/Actions';

function mapStateToProps(state, ownProps) {
  return {
    id: ownProps.id,
    type: state.notebook.protocolSection.scene.apparatus.pipettes[ownProps.id-1].type,
    voltage:  state.notebook.protocolSection.scene.apparatus.powerSupply[0].voltage,
    watts:  state.notebook.protocolSection.scene.apparatus.powerSupply[0].watts,
    current:  state.notebook.protocolSection.scene.apparatus.powerSupply[0].current,
    timer:  state.notebook.protocolSection.scene.apparatus.powerSupply[0].timer,
    power:  state.notebook.protocolSection.scene.apparatus.powerSupply[0].power,
    active:  state.notebook.protocolSection.scene.apparatus.powerSupply[0].active,
    anodeConnected:  state.notebook.protocolSection.scene.apparatus.powerSupply[0].anodeConnected,
    cathodeConnected:  state.notebook.protocolSection.scene.apparatus.powerSupply[0].cathodeConnected,
    gelbox:  state.notebook.protocolSection.scene.apparatus.gelBoxes[0],
    display:  state.notebook.protocolSection.scene.modal.display,
    notebookExpanded: !state.notebook.notebookCollapsed,
  }
}

function mapDispatchToProps(dispatch) {
  return {
    showModal: (data) => {
      dispatch(showModal(data))
    },
    incPowerSupplyTime: (data) => {
      dispatch(incPowerSupplyTime(data))
    },
    decPowerSupplyTime: (data) => {
      dispatch(decPowerSupplyTime(data))
    },
    countDownPowerSupplyTime: (data) => {
      dispatch(countDownPowerSupplyTime(data))
    },
    resetPowerSupplyTime: (data) => {
      dispatch(resetPowerSupplyTime(data))
    },
    incPowerSupplyAmp: (data) => {
      dispatch(incPowerSupplyAmp(data))
    },
    decPowerSupplyAmp: (data) => {
      dispatch(decPowerSupplyAmp(data))
    },
    incPowerSupplyWatt: (data) => {
      dispatch(incPowerSupplyWatt(data))
    },
    decPowerSupplyWatt: (data) => {
      dispatch(decPowerSupplyWatt(data))
    },
    incPowerSupplyVoltage: (data) => {
      dispatch(incPowerSupplyVoltage(data))
    },
    decPowerSupplyVoltage: (data) => {
      dispatch(decPowerSupplyVoltage(data))
    },
    togglePowerSupplyPower: (data) => {
      dispatch(togglePowerSupplyPower(data))
    },
    togglePowerSupplyStart: (data) => {
      dispatch(togglePowerSupplyStart(data))
    },
    setGelResult: (data) => {
      dispatch(setGelResult(data))
    }
  }
}

export const PowerSupplyControls = connect(
  mapStateToProps,
  mapDispatchToProps
)(Component);
